"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mockedCartMaterialWithoutCartItemResponse = exports.mockedCartMaterialResponse = void 0;
const omit_util_1 = require("../../utils/omit.util");
const cart_item_1 = require("../cart-item");
const color_option_1 = require("../color-option");
const option_1 = require("../option");
exports.mockedCartMaterialResponse = {
  id: 1,
  colorOption: color_option_1.mockedColorOptionResponse,
  options: [option_1.mockedOptionResponse],
  cartItem: cart_item_1.mockedCartItemWithoutMaterialResponse
};
exports.mockedCartMaterialWithoutCartItemResponse = omit_util_1.omitObject(exports.mockedCartMaterialResponse, 'cartItem');